export default __webpack_public_path__ + "static/media/sw-done.17ba7aa6.svg";